angular
    .module('app')
    .component('contractsEdit', {
        templateUrl: '/templates/pages/contracts/contractsEdit/contractsEdit.html',
        controller: 'ContractEditController',
        controllerAs: 'vm',
    });